import React from "react";
import "../styles/Support.css";

const contacts = [
  {
    title: "Technical Heads",
    members: [
      { name: "Nitesh Kumar Pandey", phone: "+91 7061474588", team_num: "tel:+91 7061474588" },
      { name: "Jayendra choudhary", phone: "+91 7689919139", team_num: "tel:+91 7689919139" },
      { name: "Mohit Sharma", phone: "+91 8109618103", team_num: "tel:+91 8109618103" },
    ],
  },
  {
    title: "Media Heads",
    members: [
      { name: "Mithul Kalal", phone: "+91 7726066155", team_num: "tel:+91 7726066155" },
      { name: "Kushal Mahawar", phone: "+91 6367828788", team_num: "tel:+91 6367828788" },
      { name: "Sahil Suman", phone: "+91 9431694894", team_num: "tel:+91 9431694894" },
    ],
  },
  {
    title: "Sponsorship Heads",
    members: [
      { name: "Naman Soni", phone: "+91 9664464843", team_num: "tel:+91 9664464843" },
      { name: "Kushal Mahawar", phone: "+91 6367828788", team_num: "tel:+91 6367828788" },
      { name: "Mithul Kalal", phone: "+91 7726066155", team_num: "tel:+91 7726066155" },
    ],
  },
  {
    title: "Public Relation Heads",
    members: [
      { name: "Hitesh Kumar Sharma", phone: "+91 9667442138", team_num: "tel:+91 9667442138" },
      { name: "Naman Soni", phone: "+91 9664464843", team_num: "tel:+91 9664464843" },
      { name: "Sahil Suman", phone: "+91 9431694894", team_num: "tel:+91 9431694894" },
    ],
  },
];

const ContactUs = () => {
  return (
    <div className="contact-container">
      <div className="main-background1">
        <source className="main_bg_cont1" />
      </div>

      <h2>Contact Us</h2>
      <div className="contact-grid">
        {contacts.map((group, index) => (
          <div key={index} className="contact-card">
            <h3>{group.title}</h3>
            {group.members.map((member, idx) => (
              <p key={idx}>
                {member.name}
                <br />
                <a className="team_num_link" href={member.team_num}>{member.phone}</a>
              </p>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ContactUs;
